'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrapTypeahead = require('react-bootstrap-typeahead');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _accessibilityUtils = require('./accessibilityUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// This adds a number of extra features of the basic react-bootstrap-typeahead:
// 1. Upon menu item selection, makes sure that blur is fired after the component value updates
// 2. Allows the use of enter and escape to hide the menu suggestions
// 3. Allows the use of down arrow to show the menu when it is hidden
// 4. Adds `hideLastMatch` to allow the user to hide the menu if the last item matches the
//    input value
// 5. adds `value`to allow the user to update the value of the input from outside
var Typeahead = function (_React$Component) {
	_inherits(Typeahead, _React$Component);

	function Typeahead(props) {
		_classCallCheck(this, Typeahead);

		var _this = _possibleConstructorReturn(this, (Typeahead.__proto__ || Object.getPrototypeOf(Typeahead)).call(this, props));

		_this.handleKeys = _this.handleKeys.bind(_this);
		_this.renderMenu = _this.renderMenu.bind(_this);
		_this.setInternalState = _this.setInternalState.bind(_this);
		_this.getInternalState = _this.getInternalState.bind(_this);
		_this.menuShowing = false;
		_this.state = {
			active: false // menu is only active once we start typing
		};
		return _this;
	}

	_createClass(Typeahead, [{
		key: 'handleKeys',
		value: function handleKeys(e) {
			var _this2 = this;

			if (this.state.active) {
				// If they type something new and hit enter or esc then hide the menu
				(0, _accessibilityUtils.OnKey)(e, [_accessibilityUtils.Keys.enter, _accessibilityUtils.Keys.escape], function () {
					_this2.setState({ active: false });
				});
			}
			// Activate menu if not already when pressing down arrow
			(0, _accessibilityUtils.OnKey)(e, [_accessibilityUtils.Keys.down_arrow], function () {
				_this2.setInternalState({ showMenu: true });
				_this2.setState({ active: true });
			});
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(results, menuProps) {
			var _props = this.props,
			    hideLastMatch = _props.hideLastMatch,
			    renderMenuItemChildren = _props.renderMenuItemChildren;
			// hide the last remaining item if it's typed in the text box

			var hlm = hideLastMatch && results.length === 1 && results[0] === menuProps.text;
			// has no results, or the last match is hidden
			if (hlm) {
				return _react2.default.createElement('div', null);
			}

			return _react2.default.createElement(
				_reactBootstrapTypeahead.Menu,
				_extends({}, menuProps, { className: 'typeahead typeahead-menu' }),
				results.map(function (result, index) {
					return _react2.default.createElement(
						_reactBootstrapTypeahead.MenuItem,
						{ option: result, position: index, key: result + '_' + index },
						renderMenuItemChildren(result, menuProps)
					);
				})
			);
		}
	}, {
		key: 'getInternalState',
		value: function getInternalState() {
			return this.input ? this.input.getInstance().state : {};
		}
	}, {
		key: 'setInternalState',
		value: function setInternalState(state, cb) {
			this.input && this.input.getInstance().setState(state, cb);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(props) {
			var value = props.value;
			// The default component is not controlled. This makes it semi-controlled
			// by force-updating the value based on the 'input' prop when it changes.

			if (value !== undefined) {
				this.setInternalState({ text: value });
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props2 = this.props,
			    renderMenu = _props2.renderMenu,
			    options = _props2.options,
			    className = _props2.className,
			    value = _props2.value,
			    defaultInputValue = _props2.defaultInputValue,
			    _onInputChange = _props2.onInputChange,
			    _onMenuHide = _props2.onMenuHide,
			    _onBlur = _props2.onBlur,
			    onKeyDown = _props2.onKeyDown,
			    emptyLabel = _props2.emptyLabel;


			return _react2.default.createElement(_reactBootstrapTypeahead.Typeahead, _extends({}, this.props, {
				ref: function ref(input) {
					_this3.input = input;
				},
				defaultInputValue: defaultInputValue || value,
				className: (0, _classnames2.default)('typeahead', { inactive: !this.state.active }, className)
				// dont render any options if the state is inactive
				, options: this.state.active ? options : []
				// don't show the "no matches" text when inactive
				, emptyLabel: this.state.active ? emptyLabel : null,
				onKeyDown: onKeyDown || this.handleKeys,
				onInputChange: function onInputChange(e) {
					_this3.setState({ active: true });
					_onInputChange && _onInputChange(e);
				},
				renderMenu: renderMenu || this.renderMenu,
				onMenuHide: function onMenuHide() {
					_onMenuHide && _onMenuHide();
					if (_this3.deferredBlur) {
						_this3.setState({ active: false });
						_onBlur && _onBlur(_this3.deferredBlur);
						delete _this3.deferredBlur;
					}
				},
				onBlur: function onBlur(ev) {
					if (!_this3.getInternalState().showMenu) {
						_this3.setState({ active: false });
						return _onBlur && _onBlur(ev);
					}
					// If menu is showing and the user clicks on it then blur
					// will happen on the input before the onInputChange takes place.
					// Defering the blur event, as otherwise this would mean onBlur
					// was called with the old value from the input and not the value clicked on.
					ev.persist();
					_this3.deferredBlur = ev;
				}
			}));
		}
	}]);

	return Typeahead;
}(_react2.default.Component);

Typeahead.propTypes = {
	/**
  * Bool to determine if we want to hide the menu if the input value
  * matches the last remaining option
  */
	hideLastMatch: _propTypes2.default.bool,
	/**
  * Method for rending the menu item's children. Cannot be used in tandom with
  * a custom renderMenu prop.
  */
	renderMenuItemChildren: _propTypes2.default.func,
	/**
  * Custom method for rendering the menu and its children. The renderMenuItemChildren
  * prop will be ignored if this is supplied
  */
	renderMenu: _propTypes2.default.func,
	/**
  * The options to be rendered in the menu
  */
	options: _propTypes2.default.array.isRequired,
	/**
  * Custom callback fired when user types
  */
	onInputChange: _propTypes2.default.func,
	/**
  * Custom callback fired when the menu is hidden
  */
	onMenuHide: _propTypes2.default.func,
	/**
  * Custom callback fired when the input is blurred
  */
	onBlur: _propTypes2.default.func,
	/**
  * Custom callback fired on keyDown
  */
	onKeyDown: _propTypes2.default.func,
	/**
  * Current controlled value of the input
 */
	value: _propTypes2.default.string
};

// See https://github.com/ericgio/react-bootstrap-typeahead/blob/4f2423b83aa0c0e96aaf6f7c8f88c25aebeca0a3/docs/Props.md
// for more props
Typeahead.defaultProps = {
	renderMenuItemChildren: function renderMenuItemChildren(option, props) {
		return _react2.default.createElement(
			_reactBootstrapTypeahead.Highlighter,
			{ search: props.text },
			option
		);
	},
	hideLastMatch: false
};

var _default = Typeahead;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(Typeahead, 'Typeahead', 'src/components/Typeahead.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/Typeahead.jsx');
}();

;